import {
  Button,
  Col,
  Row,
  Select,
  Input,
  InputNumber,
  AutoComplete,
  Form,
} from '@oscar/theme';
import { DownOutlined } from '@ant-design/icons';
import { ActionField, Field, useFormContext } from '@oscar/form';
import { AddedFormProps } from 'common/components/FormList/types';
import { FileUploaded, InputText, TextField } from 'common/components';
import { handleMaxAutoComplete } from 'features/insulation/utils';
import { APIS } from 'common/constants/endpoints';
import useStatus from 'views/pages/create-instrulation/hooks/useStatus';
import { useEffect, useState } from 'react';

const { Option } = Select;

const CreateForm = (props: AddedFormProps) => {
  const { field, addItem, removeItem, onCreateItem, setDefault } = props;
  const [statusRequest] = useStatus();
  const [formContext] = useFormContext();
  const setDefaultThickness = setDefault;
  const metaDataProposalDetail =
    formContext.selectors?.getDataByKey('metaDataProposalDetail') || {};
  const BillingDetail = formContext.form?.getFieldValue([
    'proposalBillingDetail',
    'data',
  ]);
  const flag = formContext.form?.getFieldValue('flag');
  const idFromEdit = formContext.form?.getFieldValue('idFromEdit');

  const proposalBillingDetail = BillingDetail.filter(
    (item: any) => item?.id === idFromEdit,
  );

  const getIndex = BillingDetail.findIndex(
    (item: any) => item?.id === idFromEdit,
  );

  useEffect(() => {
    console.log(field, 'from effect');
  }, []);

  const getPaintingWorkDetail =
    formContext.selectors?.getDataByKey('getPaintingWorkDetail') || {};

  const { submitQAQCsTime } = formContext.selectors?.getInitalValue() || {};
  const checkPaintingFinal = (statusRequestParam: any) => {
    return (
      statusRequestParam?.status &&
      statusRequestParam?.status.includes('PENDING_PAINTING') &&
      submitQAQCsTime.submittedTime === submitQAQCsTime.needToSubmittedTime - 1
    );
  };
  if (!field) return <p>Empty</p>;
  return (
    <div key={field!.key}>
      <div className="notification-detail">
        <div className="notification-detail-content create-form-search">
          {statusRequest?.type !== 'PAINTING' && (
            <>
              <div className="search-header">
                <Row gutter={12}>
                  <Col span={16}>
                    <div>
                      <p>Type of Insulation Work</p>
                      <Field
                        shouldUpdate
                        {...field}
                        name={[field!.name, 'insulationWorkOtherDescription']}
                        fieldKey={[
                          field!.fieldKey,
                          'insulationWorkOtherDescription',
                        ]}
                        normalize={(e: any) => handleMaxAutoComplete(e, 40)}
                        initialValue={
                          flag === 'EDIT'
                            ? proposalBillingDetail?.[0]
                                ?.insulationWorkOtherDescription
                            : ''
                        }
                      >
                        <AutoComplete
                          placeholder="Select Insulation Work"
                          suffixIcon={<DownOutlined />}
                          className="discipline"
                          allowClear
                          defaultValue={
                            flag === 'EDIT'
                              ? proposalBillingDetail?.[0]
                                  ?.insulationWorkOtherDescription
                              : ''
                          }
                          options={metaDataProposalDetail?.insulationWork?.map?.(
                            (item: any) => ({
                              value: item.label,
                              label: item.label,
                            }),
                          )}
                          filterOption={(inputValue: string, option: any) =>
                            option!.label
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                        />
                      </Field>
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="form-button">
                      <ActionField name="subForm" request={{ name: 'test' }}>
                        {(subProps: any) => {
                          const data = subProps.field.getFieldValue([
                            'proposalBillingDetail',
                            'data',
                          ]);

                          const itemAdd = data[data.length - 1];

                          const isEmpty =
                            flag === 'EDIT'
                              ? itemAdd.insulationWorkOtherDescription &&
                                itemAdd.workItemOtherDescription &&
                                itemAdd.metalCladdingOtherDescription &&
                                itemAdd.materialOtherDescription &&
                                itemAdd.sizeOtherDescription &&
                                itemAdd.measurement &&
                                itemAdd.unitOtherDescription &&
                                itemAdd.poNumber &&
                                itemAdd.finalMeasurement &&
                                itemAdd.finalCost
                              : itemAdd.insulationWorkOtherDescription &&
                                itemAdd.workItemOtherDescription &&
                                itemAdd.metalCladdingOtherDescription &&
                                itemAdd.materialOtherDescription &&
                                itemAdd.sizeOtherDescription &&
                                itemAdd.measurement &&
                                itemAdd.unitOtherDescription &&
                                itemAdd.quotedCost &&
                                itemAdd.poNumber;
                          return (
                            <div className="action-button">
                              <Button
                                type="secondary"
                                size="small"
                                className="reset-button"
                                onClick={() => {
                                  removeItem?.(field);
                                }}
                              >
                                Reset
                              </Button>{' '}
                              <Button
                                type="primary"
                                size="small"
                                disabled={!isEmpty}
                                className="remove-button"
                                onClick={() => {
                                  flag === 'EDIT'
                                    ? addItem?.(field)
                                    : addItem?.(field);
                                }}
                              >
                                {flag === 'EDIT' ? 'Update' : 'Add to List'}
                              </Button>
                            </div>
                          );
                        }}
                      </ActionField>
                    </div>
                  </Col>
                </Row>
              </div>

              <Row gutter={12}>
                <Col span={8}>
                  <p>Work Item</p>
                  <Field
                    {...field}
                    name={[field!.name, 'workItemOtherDescription']}
                    fieldKey={[field!.fieldKey, 'workItemOtherDescription']}
                    normalize={(e: any) => handleMaxAutoComplete(e, 40)}
                    initialValue={
                      flag === 'EDIT'
                        ? proposalBillingDetail?.[0]?.workItemOtherDescription
                        : ''
                    }
                  >
                    <AutoComplete
                      placeholder="Select Work Item"
                      suffixIcon={<DownOutlined />}
                      className="discipline"
                      allowClear
                      defaultValue={
                        flag === 'EDIT'
                          ? proposalBillingDetail?.[0]?.workItemOtherDescription
                          : ''
                      }
                      options={metaDataProposalDetail?.workItem?.map?.(
                        (item: any) => ({
                          value: item.label,
                          label: item.label,
                        }),
                      )}
                      filterOption={(inputValue: string, option: any) =>
                        option!.label
                          .toUpperCase()
                          .indexOf(inputValue.toUpperCase()) !== -1
                      }
                    />
                  </Field>
                </Col>
                <Col span={8}>
                  <p>Meta Cladding</p>
                  <Field
                    {...field}
                    name={[field!.name, 'metalCladdingOtherDescription']}
                    fieldKey={[
                      field!.fieldKey,
                      'metalCladdingOtherDescription',
                    ]}
                    normalize={(e: any) => handleMaxAutoComplete(e, 40)}
                    initialValue={
                      flag === 'EDIT'
                        ? proposalBillingDetail?.[0]
                            ?.metalCladdingOtherDescription
                        : ''
                    }
                  >
                    <AutoComplete
                      placeholder="Select Metal Cladding"
                      suffixIcon={<DownOutlined />}
                      className="discipline"
                      allowClear
                      defaultValue={
                        flag === 'EDIT'
                          ? proposalBillingDetail?.[0]
                              ?.metalCladdingOtherDescription
                          : ''
                      }
                      options={metaDataProposalDetail?.metaCladding?.map?.(
                        (item: any) => ({
                          value: item.label,
                          label: item.label,
                        }),
                      )}
                      filterOption={(inputValue: string, option: any) =>
                        option!.label
                          .toUpperCase()
                          .indexOf(inputValue.toUpperCase()) !== -1
                      }
                    />
                  </Field>
                </Col>
                <Col span={8}>
                  <p>Insulation Material</p>
                  <Field
                    {...field}
                    name={[field!.name, 'materialOtherDescription']}
                    fieldKey={[field!.fieldKey, 'materialOtherDescription']}
                    normalize={(e: any) => handleMaxAutoComplete(e, 40)}
                    initialValue={
                      flag === 'EDIT'
                        ? proposalBillingDetail?.[0]?.materialOtherDescription
                        : ''
                    }
                  >
                    <AutoComplete
                      placeholder="Select Insulation Material"
                      suffixIcon={<DownOutlined />}
                      className="discipline"
                      allowClear
                      defaultValue={
                        flag === 'EDIT'
                          ? proposalBillingDetail?.[0]?.materialOtherDescription
                          : ''
                      }
                      options={metaDataProposalDetail?.insulationMaterial?.map?.(
                        (item: any) => ({
                          value: item.label,
                          label: item.label,
                        }),
                      )}
                      filterOption={(inputValue: string, option: any) =>
                        option!.label
                          .toUpperCase()
                          .indexOf(inputValue.toUpperCase()) !== -1
                      }
                      onChange={onCreateItem}
                    />
                  </Field>
                </Col>
              </Row>
              <Row gutter={12}>
                <Col span={8}>
                  <p>Size</p>
                  <Field
                    {...field}
                    name={[field!.name, 'sizeOtherDescription']}
                    fieldKey={[field!.fieldKey, 'sizeOtherDescription']}
                    normalize={(e: any) => handleMaxAutoComplete(e, 40)}
                    initialValue={
                      flag === 'EDIT'
                        ? proposalBillingDetail?.[0]?.sizeOtherDescription
                        : ''
                    }
                  >
                    <AutoComplete
                      placeholder="Select Size"
                      suffixIcon={<DownOutlined />}
                      className="discipline"
                      allowClear
                      defaultValue={
                        flag === 'EDIT'
                          ? proposalBillingDetail?.[0]?.sizeOtherDescription
                          : ''
                      }
                      options={metaDataProposalDetail?.size?.map?.(
                        (item: any) => ({
                          value: item.label,
                          label: item.label,
                        }),
                      )}
                      filterOption={(inputValue: string, option: any) =>
                        option!.label
                          .toUpperCase()
                          .indexOf(inputValue.toUpperCase()) !== -1
                      }
                    />
                  </Field>
                </Col>
                <Col span={8}>
                  <p>Thickness</p>
                  <Field
                    {...field}
                    name={[field!.name, 'thicknessOtherDescription']}
                    fieldKey={[field!.fieldKey, 'thicknessOtherDescription']}
                    normalize={(e: any) => handleMaxAutoComplete(e, 40)}
                    initialValue={
                      flag === 'EDIT'
                        ? proposalBillingDetail?.[0]?.thicknessOtherDescription
                        : ''
                    }
                  >
                    <AutoComplete
                      placeholder="Select Thickness"
                      suffixIcon={<DownOutlined />}
                      className="discipline"
                      allowClear
                      defaultValue={
                        flag === 'EDIT'
                          ? proposalBillingDetail?.[0]
                              ?.thicknessOtherDescription
                          : ''
                      }
                      options={metaDataProposalDetail?.thickness?.map?.(
                        (item: any) => ({
                          value: item.label,
                          label: item.label,
                        }),
                      )}
                      filterOption={(inputValue: string, option: any) =>
                        option!.label
                          .toUpperCase()
                          .indexOf(inputValue.toUpperCase()) !== -1
                      }
                      value={setDefaultThickness}
                      disabled={props.disableThickness}
                    />
                  </Field>
                </Col>
                <Col span={8}>
                  <p>PO Number</p>
                  <Field
                    {...field}
                    name={[field!.name, 'poNumber']}
                    fieldKey={[field!.fieldKey, 'poNumber']}
                    //normalize={(e: any) => handleMaxPoNumber(e, 20)}
                    rules={[
                      {
                        pattern: new RegExp(/^[0-9-+()]*$/),
                        message: 'Field does not accept alphabet',
                      },
                    ]}
                    initialValue={
                      flag === 'EDIT'
                        ? proposalBillingDetail?.[0]?.poNumber
                        : ''
                    }
                  >
                    <Input
                      style={{
                        width: '95%',
                      }}
                      placeholder="PO Number"
                      type="text"
                      defaultValue={
                        flag === 'EDIT'
                          ? proposalBillingDetail?.[0]?.poNumber
                          : ''
                      }
                    />
                  </Field>
                </Col>
              </Row>
              {flag === 'EDIT' && (
                <Row gutter={12}>
                  <Col span={8}>
                    <p>PO Number 2</p>
                    <Field
                      {...field}
                      name={[field!.name, 'poNumber1']}
                      fieldKey={[field!.fieldKey, 'poNumber1']}
                      //normalize={(e: any) => handleMaxPoNumber(e, 20)}
                      rules={[
                        {
                          pattern: new RegExp(/^[0-9-+()]*$/),
                          message: 'Field does not accept alphabet',
                        },
                      ]}
                      initialValue={
                        flag === 'EDIT'
                          ? proposalBillingDetail?.[0]?.poNumber1
                          : ''
                      }
                    >
                      <Input
                        style={{
                          width: '95%',
                        }}
                        placeholder="PO Number 2"
                        type="text"
                        defaultValue={
                          flag === 'EDIT'
                            ? proposalBillingDetail?.[0]?.poNumber1
                            : ''
                        }
                      />
                    </Field>
                  </Col>
                  <Col span={8}>
                    <p>PO Number 3</p>
                    <Field
                      {...field}
                      name={[field!.name, 'poNumber2']}
                      fieldKey={[field!.fieldKey, 'poNumber2']}
                      //normalize={(e: any) => handleMaxPoNumber(e, 20)}
                      rules={[
                        {
                          pattern: new RegExp(/^[0-9-+()]*$/),
                          message: 'Field does not accept alphabet',
                        },
                      ]}
                      initialValue={
                        flag === 'EDIT'
                          ? proposalBillingDetail?.[0]?.poNumber2
                          : ''
                      }
                    >
                      <Input
                        style={{
                          width: '95%',
                        }}
                        placeholder="PO Number 3"
                        type="text"
                        defaultValue={
                          flag === 'EDIT'
                            ? proposalBillingDetail?.[0]?.poNumber2
                            : ''
                        }
                      />
                    </Field>
                  </Col>
                  <Col span={8}>
                    <p>PO Number 4</p>
                    <Field
                      {...field}
                      name={[field!.name, 'poNumber3']}
                      fieldKey={[field!.fieldKey, 'poNumber3']}
                      //normalize={(e: any) => handleMaxPoNumber(e, 20)}
                      rules={[
                        {
                          pattern: new RegExp(/^[0-9-+()]*$/),
                          message: 'Field does not accept alphabet',
                        },
                      ]}
                      initialValue={
                        flag === 'EDIT'
                          ? proposalBillingDetail?.[0]?.poNumber3
                          : ''
                      }
                    >
                      <Input
                        style={{
                          width: '95%',
                        }}
                        placeholder="PO Number 4"
                        type="text"
                        defaultValue={
                          flag === 'EDIT'
                            ? proposalBillingDetail?.[0]?.poNumber3
                            : ''
                        }
                      />
                    </Field>
                  </Col>
                </Row>
              )}
              <Row gutter={12}>
                <Col span={8}>
                  <p>Measurement</p>
                  <Field
                    {...field}
                    name={[field!.name, 'measurement']}
                    fieldKey={[field!.fieldKey, 'measurement']}
                    initialValue={
                      flag === 'EDIT'
                        ? proposalBillingDetail?.[0]?.measurement
                        : ''
                    }
                  >
                    <InputNumber
                      placeholder="Measurement"
                      min="0"
                      decimalSeparator="."
                      precision={2}
                      defaultValue={
                        flag === 'EDIT'
                          ? proposalBillingDetail?.[0]?.measurement
                          : ''
                      }
                    />
                  </Field>
                </Col>
                <Col span={8}>
                  <p>Unit</p>
                  <Field
                    {...field}
                    name={[field!.name, 'unitOtherDescription']}
                    fieldKey={[field!.fieldKey, 'unitOtherDescription']}
                    normalize={(e: any) => handleMaxAutoComplete(e, 40)}
                    initialValue={
                      flag === 'EDIT'
                        ? proposalBillingDetail?.[0]?.unitOtherDescription
                        : ''
                    }
                  >
                    <Select
                      placeholder="Select Unit"
                      suffixIcon={<DownOutlined />}
                      className="discipline"
                      allowClear
                      notFoundContent
                      defaultValue={
                        flag === 'EDIT'
                          ? proposalBillingDetail?.[0]?.unitOtherDescription
                          : ''
                      }
                      options={metaDataProposalDetail?.unit?.map?.(
                        (item: any) => ({
                          value: item.label,
                          label: item.label,
                        }),
                      )}
                      filterOption={(inputValue: string, option: any) =>
                        option!.label
                          .toUpperCase()
                          .indexOf(inputValue.toUpperCase()) !== -1
                      }
                    />
                  </Field>
                  <Field name={[field!.key, 'new']} initialValue={true}></Field>
                </Col>
                <Col span={8}>
                  {flag !== 'EDIT' ? (
                    <>
                      <p>Quoted Cost (RM)</p>
                      <Field
                        {...field}
                        name={[field!.name, 'quotedCost']}
                        fieldKey={[field!.fieldKey, 'quotedCost']}
                        initialValue={
                          flag === 'EDIT'
                            ? proposalBillingDetail?.[0]?.quotedCost
                            : ''
                        }
                      >
                        <InputNumber
                          placeholder="Quoted Cost"
                          min="0"
                          decimalSeparator="."
                          precision={2}
                          defaultValue={
                            flag === 'EDIT'
                              ? proposalBillingDetail?.[0]?.quotedCost
                              : ''
                          }
                        />
                      </Field>{' '}
                    </>
                  ) : (
                    <TextField
                      label="Quoted Cost (RM)"
                      value={proposalBillingDetail?.[0]?.quotedCost}
                    />
                  )}
                </Col>
              </Row>
              {/* <Row>
                <Col span={24}>
                  <p>Quoted Cost (RM)</p>
                  <Field
                    {...field}
                    name={[field!.name, 'quotedCost']}
                    fieldKey={[field!.fieldKey, 'quotedCost']}
                  >
                    <InputNumber
                      placeholder="Quoted Cost"
                      min="0"
                      decimalSeparator="."
                      precision={2}
                    />
                  </Field>
                </Col>
              </Row> */}
              {statusRequest?.status === 'PENDING_REINSTATEMENT' && (
                <Row gutter={12}>
                  <Col span={8}>
                    <p>Final Measurement</p>
                    <Field
                      name={[field!.name, 'finalMeasurement']}
                      fieldKey={[field!.fieldKey, 'finalMeasurement']}
                      initialValue={
                        flag === 'EDIT'
                          ? proposalBillingDetail?.[0]?.finalMeasurement
                          : ''
                      }
                    >
                      <InputNumber
                        placeholder="Final Measurement"
                        min="0"
                        decimalSeparator="."
                        precision={2}
                        defaultValue={
                          flag === 'EDIT'
                            ? proposalBillingDetail?.[0]?.finalMeasurement
                            : ''
                        }
                      />
                    </Field>
                  </Col>
                  <Col span={8}>
                    <p>Unit</p>
                    <Field name={[field!.name, 'unit']}>
                      <InputText mappingData={metaDataProposalDetail?.unit} />
                    </Field>
                  </Col>
                  <Col span={8}>
                    <p>Final Cost (RM)</p>
                    <Field
                      name={[field!.key, 'finalCost']}
                      initialValue={
                        flag === 'EDIT'
                          ? proposalBillingDetail?.[0]?.finalCost
                          : ''
                      }
                    >
                      <InputNumber
                        placeholder="Final Cost"
                        type="number"
                        decimalSeparator="."
                        precision={2}
                        defaultValue={
                          flag === 'EDIT'
                            ? proposalBillingDetail?.[0]?.finalCost
                            : ''
                        }
                      />
                    </Field>
                    <Field
                      name={[field!.key, 'WorklistID']}
                      initialValue={
                        flag === 'EDIT' ? proposalBillingDetail?.[0]?.id : null
                      }
                    ></Field>
                    {proposalBillingDetail?.[0]?.WorklistID && (
                      <Field
                        name={[field!.key, 'Id']}
                        initialValue={
                          flag === 'EDIT'
                            ? proposalBillingDetail?.[0]?.id
                            : null
                        }
                      ></Field>
                    )}
                    <Field
                      name={[field!.key, 'Updated']}
                      initialValue={flag === 'EDIT' ? true : false}
                    ></Field>
                    <Field
                      name={[field!.key, 'time']}
                      initialValue={flag === 'EDIT' ? Date.now() : null}
                    ></Field>

                    <Field
                      name={[getIndex, 'edited']}
                      initialValue={flag === 'EDIT' ? true : false}
                    ></Field>
                  </Col>
                </Row>
              )}
            </>
          )}

          {statusRequest?.type === 'PAINTING' && (
            <>
              <div className="search-header">
                <Row gutter={12}>
                  <Col span={16}>
                    <div>
                      <p>Item Description</p>
                      <Field
                        shouldUpdate
                        {...field}
                        name={[field!.name, 'itemDescription']}
                        fieldKey={[field!.fieldKey, 'itemDescription']}
                        normalize={(e: any) => handleMaxAutoComplete(e, 100)}
                        initialValue={
                          flag === 'EDIT'
                            ? proposalBillingDetail?.[0]?.itemDescription
                            : ''
                        }
                      >
                        <Input placeholder="Item Description" min="0" />
                      </Field>
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="form-button">
                      <ActionField name="subForm" request={{ name: 'test' }}>
                        {(subProps: any) => {
                          const data = subProps.field.getFieldValue([
                            'proposalBillingDetail',
                            'data',
                          ]);
                          const isAddToList = data[data.length - 1];
                          const isEmpty =
                            flag === 'EDIT'
                              ? isAddToList.itemDescription &&
                                isAddToList.estimatedMeasurement &&
                                isAddToList.uom &&
                                isAddToList.quotedCost &&
                                isAddToList.poNumber &&
                                isAddToList.finalCost &&
                                isAddToList.finalMeasurement
                              : isAddToList.itemDescription &&
                                isAddToList.estimatedMeasurement &&
                                isAddToList.uom &&
                                isAddToList.quotedCost &&
                                isAddToList.poNumber;

                          return (
                            <div className="action-button">
                              <Button
                                type="secondary"
                                size="small"
                                className="reset-button"
                                onClick={() => {
                                  removeItem?.(field);
                                }}
                              >
                                Reset
                              </Button>{' '}
                              <Button
                                type="primary"
                                size="small"
                                disabled={!isEmpty}
                                className="remove-button"
                                onClick={() => {
                                  addItem?.(field);
                                }}
                              >
                                {flag === 'EDIT' ? 'Update' : 'Add to List'}
                              </Button>
                            </div>
                          );
                        }}
                      </ActionField>
                    </div>
                  </Col>
                </Row>
              </div>

              <Row gutter={12}>
                <Col span={12}>
                  <p>Estimated Measurement</p>
                  <Field
                    {...field}
                    name={[field!.name, 'estimatedMeasurement']}
                    fieldKey={[field!.fieldKey, 'estimatedMeasurement']}
                    initialValue={
                      flag === 'EDIT'
                        ? proposalBillingDetail?.[0]?.estimatedMeasurement
                        : ''
                    }
                  >
                    <InputNumber
                      placeholder="Measurement"
                      min="0"
                      decimalSeparator="."
                      precision={2}
                    />
                    {/* <Select
                      placeholder="Select Estimated Measurement"
                      suffixIcon={<DownOutlined />}
                      className="discipline"
                      allowClear
                    >
                      {metaDataProposalDetail?.unit?.map?.(
                        (item: any, index: number) => (
                          <Option key={`${item}-${index}`} value={item?.id}>
                            {item.label}
                          </Option>
                        ),
                      )}
                    </Select> */}
                  </Field>
                </Col>
                <Col span={12}>
                  <p>UOM</p>
                  <Field
                    {...field}
                    name={[field!.name, 'uom']}
                    fieldKey={[field!.fieldKey, 'uom']}
                    initialValue={
                      flag === 'EDIT' ? proposalBillingDetail?.[0]?.uom : ''
                    }
                  >
                    <Select
                      placeholder="Select UOM"
                      suffixIcon={<DownOutlined />}
                      className="discipline"
                      allowClear
                    >
                      {getPaintingWorkDetail?.uom?.map?.(
                        (item: any, index: number) => (
                          <Option key={`${item}-${index}`} value={item?.id}>
                            {item.label}
                          </Option>
                        ),
                      )}
                    </Select>
                  </Field>
                </Col>
                <Col span={12}>
                  {flag !== 'EDIT ' ? (
                    <>
                      <p>Quoted Cost (RM)</p>{' '}
                      <Field
                        {...field}
                        name={[field!.name, 'quotedCost']}
                        fieldKey={[field!.fieldKey, 'quotedCost']}
                        initialValue={
                          flag === 'EDIT'
                            ? proposalBillingDetail?.[0]?.quotedCost
                            : ''
                        }
                      >
                        <InputNumber
                          placeholder="Quoted Cost"
                          min="0"
                          decimalSeparator="."
                          precision={2}
                        />
                      </Field>
                    </>
                  ) : (
                    <TextField
                      label="Quoted Cost (RM)"
                      value={proposalBillingDetail?.[0]?.quotedCost}
                    />
                  )}
                </Col>
                <Col span={12}>
                  <p>PO Number {flag === 'EDIT' ? '1' : ''}</p>
                  <Field
                    {...field}
                    name={[field!.name, 'poNumber']}
                    fieldKey={[field!.fieldKey, 'poNumber']}
                    //normalize={(e: any) => handleMaxPoNumber(e, 20)}
                    rules={[
                      {
                        pattern: new RegExp(/^[0-9-+()]*$/),
                        message: 'Field does not accept alphabet',
                      },
                    ]}
                    initialValue={
                      flag === 'EDIT'
                        ? proposalBillingDetail?.[0]?.poNumber
                        : ''
                    }
                  >
                    <Input
                      style={{
                        width: '95%',
                      }}
                      placeholder={`PO Number ${flag === 'EDIT' ? '1' : ''}`}
                      type="text"
                    />
                  </Field>
                </Col>
              </Row>
              {flag === 'EDIT' && (
                <Row gutter={12}>
                  <Col span={8}>
                    <p>PO Number 2</p>
                    <Field
                      {...field}
                      name={[field!.name, 'poNumber1']}
                      fieldKey={[field!.fieldKey, 'poNumber1']}
                      //normalize={(e: any) => handleMaxPoNumber(e, 20)}
                      rules={[
                        {
                          pattern: new RegExp(/^[0-9-+()]*$/),
                          message: 'Field does not accept alphabet',
                        },
                      ]}
                      initialValue={
                        flag === 'EDIT'
                          ? proposalBillingDetail?.[0]?.poNumber1
                          : ''
                      }
                    >
                      <Input
                        style={{
                          width: '95%',
                        }}
                        placeholder="PO Number"
                        type="text"
                      />
                    </Field>
                  </Col>
                  <Col span={8}>
                    <p>PO Number 3</p>
                    <Field
                      {...field}
                      name={[field!.name, 'poNumber2']}
                      fieldKey={[field!.fieldKey, 'poNumber2']}
                      //normalize={(e: any) => handleMaxPoNumber(e, 20)}
                      rules={[
                        {
                          pattern: new RegExp(/^[0-9-+()]*$/),
                          message: 'Field does not accept alphabet',
                        },
                      ]}
                      initialValue={
                        flag === 'EDIT'
                          ? proposalBillingDetail?.[0]?.poNumber2
                          : ''
                      }
                    >
                      <Input
                        style={{
                          width: '95%',
                        }}
                        placeholder="PO Number"
                        type="text"
                      />
                    </Field>
                  </Col>
                  <Col span={8}>
                    <p>PO Number 4</p>
                    <Field
                      {...field}
                      name={[field!.name, 'poNumber3']}
                      fieldKey={[field!.fieldKey, 'poNumber3']}
                      //normalize={(e: any) => handleMaxPoNumber(e, 20)}
                      rules={[
                        {
                          pattern: new RegExp(/^[0-9-+()]*$/),
                          message: 'Field does not accept alphabet',
                        },
                      ]}
                      initialValue={
                        flag === 'EDIT'
                          ? proposalBillingDetail?.[0]?.poNumber3
                          : ''
                      }
                    >
                      <Input
                        style={{
                          width: '95%',
                        }}
                        placeholder="PO Number 4"
                        type="text"
                      />
                    </Field>
                  </Col>
                </Row>
              )}

              {statusRequest.status === 'PENDING_PAINTING' ||
              checkPaintingFinal(statusRequest) ? (
                <Row gutter={12}>
                  <Col span={8}>
                    <p>Final Measurement</p>
                    <Field
                      name={[field!.name, 'finalMeasurement']}
                      fieldKey={[field!.fieldKey, 'finalMeasurement']}
                      initialValue={
                        flag === 'EDIT'
                          ? proposalBillingDetail?.[0]?.finalMeasurement
                          : ''
                      }
                    >
                      <InputNumber
                        placeholder="Final Measurement"
                        min="0"
                        decimalSeparator="."
                        precision={2}
                        defaultValue={
                          proposalBillingDetail?.[0]?.finalMeasurement
                        }
                      />
                    </Field>
                  </Col>
                  <Col span={8}>
                    <p>UOM</p>
                    <Field
                      name={[field!.key, 'uom']}
                      fieldKey={[field!.fieldKey, 'uom']}
                      initialValue={
                        flag === 'EDIT' ? proposalBillingDetail?.[0]?.uom : ''
                      }
                    >
                      <InputText mappingData={getPaintingWorkDetail?.uom} />
                    </Field>
                  </Col>
                  <Col span={8}>
                    <p>Final Cost (RM)</p>
                    <Field name={[field!.key, 'finalCost']}>
                      <InputNumber
                        placeholder="Final Cost"
                        type="number"
                        decimalSeparator="."
                        precision={2}
                      />
                    </Field>
                    <Field
                      name={[field!.key, 'WorklistID']}
                      initialValue={
                        flag === 'EDIT' ? proposalBillingDetail?.[0]?.id : null
                      }
                    ></Field>
                    {proposalBillingDetail?.[0]?.WorklistID && (
                      <Field
                        name={[field!.key, 'Id']}
                        initialValue={
                          flag === 'EDIT'
                            ? proposalBillingDetail?.[0]?.id
                            : null
                        }
                      ></Field>
                    )}
                    <Field
                      name={[field!.key, 'Updated']}
                      initialValue={flag === 'EDIT' ? true : false}
                    ></Field>
                  </Col>
                </Row>
              ) : (
                <></>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CreateForm;
